<div (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
    <div class="measurement-point-readings">
        <div *ngIf ="IsTrackRoller == true" [class.not-selected]="isHidden" >
            <table style="width: 100%;">
                <caption><b>Measured {{measure_point_title}}</b></caption>
                <thead>
                    <tr>
                        <td>Location</td>
                        <td>Left</td>
                        <td>Left Worn</td>
                        <td>Right</td>
                        <td>Right Worn</td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="isYesNoTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td>{{parseYesNo(rd.left)}}</td>
                            <td>{{rd.leftworn}} %</td>
                            <td>{{parseYesNo(rd.left)}}</td>
                            <td>{{rd.rightworn}} %</td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="isKPOTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td>{{parseKPO(rd.left)}}</td>
                            <td>{{rd.leftworn}} %</td>
                            <td>{{parseKPO(rd.right)}}</td>
                            <td>{{rd.rightworn}} %</td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="!isYesNoTool && !isKPOTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td *ngIf="rd.left == 0"></td>
                            <td  *ngIf="rd.left != 0">{{rd.left}} {{UoM}}</td>
                            <td *ngIf="rd.left == 0"></td>
                            <td *ngIf="rd.left != 0">{{rd.leftworn}} %</td>
                            <td *ngIf="rd.right == 0"></td>
                            <td  *ngIf="rd.right != 0">{{rd.right}} {{UoM}}</td>
                            <td *ngIf="rd.right == 0"></td>
                            <td  *ngIf="rd.right != 0">{{rd.rightworn}} %</td>
                        </tr>

                        <tr *ngIf="canAverage && !IsCrawlerFrame" >
                            <td><b>Average</b></td>
                            <td><b>{{averageLeft}} {{UoM}}</b></td>
                            <td><b>{{averageLeftWorn}} %</b></td>
                            <td><b>{{averageRight}} {{UoM}}</b></td>
                            <td><b>{{averageRightWorn}} %</b></td>
                        </tr>
                    </ng-container>

                </tbody>
            </table>

            <br />
            <span style="margin-left: 10px;">Tool used: {{tool}}</span>
        </div>

        <div *ngIf ="IsTrackRoller == false" [class.not-selected]="isHidden" >
            <table>
                <caption><b>Measured {{measure_point_title}}</b></caption>
                <thead>
                    <tr>
                        <td>Location</td>
                        <td>Left</td>
                        <td>Right</td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="isYesNoTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td>{{parseYesNo(rd.left)}}</td>
                            <td>{{parseYesNo(rd.right)}}</td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="isKPOTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td>{{parseKPO(rd.left)}}</td>
                            <td>{{parseKPO(rd.right)}}</td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="!isYesNoTool && !isKPOTool">
                        <tr *ngFor="let rd of readings">
                            <td>{{rd.location}}</td>
                            <td *ngIf="rd.left == 0"></td>
                            <td  *ngIf="rd.left != 0">{{rd.left}} {{UoM}}</td>
                            <td *ngIf="rd.right == 0"></td>
                            <td  *ngIf="rd.right != 0">{{rd.right}} {{UoM}}</td>
                        </tr>

                        <tr *ngIf="canAverage && !IsCrawlerFrame"  > 
                            <td><b>Average</b></td>
                            <td><b>{{averageLeft}} {{UoM}}</b></td>
                            <td><b>{{averageRight}} {{UoM}}</b></td>
                        </tr>
                    </ng-container>

                </tbody>
            </table>

            <br />
            <span style="margin-left: 10px;">Tool used: {{tool}}</span>
        </div>

        <div class="show-hide-toggle" [class.button_selected]="isHidden" (click)="toggleShowOrHide()" *ngIf="displayToggleButton" matTooltip="Toggle Show or Hide">
            <i class="material-icons show-hide-toggle__icon">not_interested</i>
        </div>
    </div>
</div>
